export default __webpack_public_path__ + "static/media/truck-travel@3x.3dc8ce4b.png";